import React from "react";
import {AboutUs} from "../components";
import {ServicesIcon} from "../assets/icons";

const AboutUsPage = () => {
    return (
        <div className="relative md:mt-60 ">
            <AboutUs hideBtn={true} displayImgs={false} />

            <div className="absolute left-0 top-0 hidden  md:block" >
                <ServicesIcon  />
            </div>
        </div>
    );
};

export default AboutUsPage;
